// extracted by mini-css-extract-plugin
export var checkbox = "_9t-0";
export var circle = "_9t-3";
export var horizontalContainer = "_9t-7";
export var sm = "_9t-5";
export var switch0 = "_9t-2";
export var switchDisabled = "_9t-8";
export var switchEnabled = "_9t-1";
export var textSwitchContainer = "_9t-9";
export var textSwitchOption = "_9t-a";
export var textSwitchOptionSelected = "_9t-b";
export var verticalContainer = "_9t-6";
export var xs = "_9t-4";